<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import HeaderDetailContent from '@/components/common/header/header-detail-content.vue';
import Content from '@/components/layouts/content.vue';
import Header from '@/components/layouts/header.vue';
import { getTabs } from '@/utils/personalNews';
import {
  useTeamInfo,
  useUserInfo,
  useUserPersonalNewsDocumentCounts,
} from '@/utils/swr';
import { useStore } from '@/utils/vue';

type Props = {
  title?: string;
  detail?: string;
};

withDefaults(defineProps<Props>(), {
  title: 'パーソナルニュース',
  detail:
    '記事にマーク、閲覧、グループマーク、コメントすることで、AIが興味にピッタリな記事をお届けします。',
});

const store = useStore();
const router = useRouter();
const { data: userInfo } = useUserInfo();
const { data: team } = useTeamInfo();
const { data: personalNewsCounts } = useUserPersonalNewsDocumentCounts();

const feedType = computed(() => store.state.feedType.feedType);
const tabs = computed(() =>
  getTabs(feedType, team, userInfo, personalNewsCounts),
);

const goToEdit = () => {
  router.push({ name: 'personalNewsEdit' });
};
</script>

<template>
  <div class="personal-news">
    <Header
      :title="title"
      :detail="detail"
      :tabs="tabs"
      content-width="var(--layout-content-width, 948px)"
      :is-one-line="false"
    >
      <template #detail-content="{ detail: headerDetail }">
        <HeaderDetailContent :detail="headerDetail">
          <template #detail>
            <span class="c-text-regular--m">{{ headerDetail }}</span>
          </template>
        </HeaderDetailContent>
      </template>
      <template #button>
        <button
          class="settings-button c-btn c-btn--small c-btn--auto"
          @click="goToEdit"
        >
          設定
        </button>
      </template>
    </Header>
    <Content>
      <slot />
    </Content>
  </div>
</template>

<style lang="scss" scoped>
.personal-news {
  width: 100%;

  .settings-button {
    white-space: nowrap;
  }
}
</style>
